import { sendAncillaryEventToCustomerIO } from '../../../../utilities/customer-io-ancillary-events';

export default (event, purchasePlace, paymentForm, storeFront, products, taxes, revenue, balance) => {
  const emd = []; 

  const mockEventData = {
    event: 'purchase',
    ecommerce: {
      purchasePlace,
      paymentForm,
      storeFront,
      revenue,
      items: products,
    },
  };
  
  sendAncillaryEventToCustomerIO('upgrades', mockEventData, balance, {
    purchaseData: {
      purchasePlace,
      paymentForm,
      storeFront,
      products,
      taxes,
      revenue,
    },
    source: 'upgrade-myb-purchase',
  });
  
  if (balance.userProfile.ffNumber) {
    try {
      const travelerCollection = balance.confirmationModel.cartConfirmation.travelerCollection;
      travelerCollection.map(travelerCollectionItem => {
        travelerCollectionItem.ancillaries.ancillaries.map( ancillarieItem => {
          if (ancillarieItem && ancillarieItem.ancillary && ancillarieItem.emd) {
            emd.push(ancillarieItem.emd);
          }
        });
      });
    } catch (error) {
      // Silent error
    }

    products.map((productItem, index) => {
      productItem.variant = emd[index];
    });
  }

  return !balance.userProfile.ffNumber ? {
    event: event,
    purchasePlace: purchasePlace,
    paymentForm: paymentForm,
    storeFront: storeFront,
    ecommerce: {
      currencyCode: balance.confirmationModel.cartConfirmation.total.currencyCode,
      purchase: {
        actionField: {
          action: 'purchase',
          affiliation: 'MYB',
          id: `${balance.pnrCode}-${balance.confirmationModel.transactionTime.format('YYYYMMDDHHmm')}`,
          revenue: revenue,
          shipping: '0',
          tax: taxes,
        },
        products: products,
      },
    },
  } : {
    event: event,
    purchasePlace: purchasePlace,
    typeofPayment: balance.confirmationModel.hasTicketedAncillary() && balance.confirmationModel.hasTicketedAncillaryPP() ? 'With points and money' : balance.confirmationModel.hasTicketedAncillary() ? 'Money' : 'Points',
    clubpremierIDP: balance.userProfile.ffNumber,
    pointsValue: balance.confirmationModel.cartConfirmation.total.totalCPPoints, // Valor en puntos totales
    revenueMYB: balance.confirmationModel.cartConfirmation.total.total,
    emdValue: emd,
    pnr: balance.pnrCode,
    numPax: balance.cart.travelerCollection.length,
    Cpmis: balance.numCP,
    ecommerce: {
      currencyCode: balance.confirmationModel.cartConfirmation.total.currencyCode,
      purchase: {
        actionField: {
          action: 'purchase',
          affiliation: 'MYB',
          id: `${balance.pnrCode}-${balance.confirmationModel.transactionTime.format('YYYYMMDDHHmm')}`,
          revenue: revenue,
          shipping: '0',
          tax: taxes,
        },
        products: products,
      },
    },
  };
};